import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogLabel: {
    id: 'aws.captcha.dialog.label',
    defaultMessage: 'Security challenge',
    description: 'Accessible label for the AWS WAF CAPTCHA dialog',
  },
  loadingLabel: {
    id: 'aws.captcha.loading.label',
    defaultMessage: 'Loading security challenge',
    description: 'Accessible label announced while the AWS WAF CAPTCHA challenge is loading',
  },
});
